import { useState, useEffect, useCallback } from "react";
import { fetchItems, markItemRead } from "../api/items";
import type { ItemListEntry, PaginatedItems, ItemFilters } from "../types";

export function useItems(initialFilters: ItemFilters) {
  const [filters, setFilters] = useState<ItemFilters>(initialFilters);
  const [data, setData] = useState<PaginatedItems | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const load = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const result = await fetchItems(filters);
      setData(result);
    } catch (e) {
      setError(e instanceof Error ? e.message : "Unbekannter Fehler");
    } finally {
      setLoading(false);
    }
  }, [filters]);

  useEffect(() => {
    load();
  }, [load]);

  const toggleRead = useCallback(
    async (item: ItemListEntry) => {
      try {
        await markItemRead(item.id, !item.is_read);
        await load();
      } catch (e) {
        console.error("Fehler beim Markieren:", e);
      }
    },
    [load]
  );

  return { data, loading, error, filters, setFilters, reload: load, toggleRead };
}
